import styled from 'styled-components';
import {
  ChevronLeft16Filled,
  ChevronRight16Filled,
} from '@fluentui/react-icons';

export const TableFooter = styled.span`
  height: 35px;
  width: 100%;
  color: ${(props) => props.theme.tableHeadFont};
  background: ${(props) => props.theme.tableHeadColor};
  border-top: 3px solid ${(props) => props.theme.tableBorders};
  position: absolute;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0.75rem;
`;

export const TablePaginationContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ArrowLeft = styled(ChevronLeft16Filled)`
  color: ${(props) => props.theme.tableHeadFont};
  cursor: pointer;
`;

export const ArrowRight = styled(ChevronRight16Filled)`
  color: ${(props) => props.theme.tableHeadFont};
  cursor: pointer;
`;

export const TablePagesContainer = styled.span`
  font-size: 14px;
  font-weight: 400;
  cursor: default;
`;
